// Source https://play.tailwindcss.com/aDlejIsuXJ
module.exports = () => ({
  ".logotype-block": {
    "@apply ds-w-full ds-flex ds-justify-center ds-max-h-3xl ds-h-3xl": true,
  },

  ".logotype-block a img": {
    "@apply ds-w-full ds-max-h-3xl ds-h-3xl": true,
  },
});
